import React from 'react'
import {connect} from 'react-redux'
import Skins from '../_data/Skins'
import {isSubmissionMenuOpen} from './ArenaView/is-submission-menu-open'
import {getCombatantIdFromSelectingString} from './get-combatant-id-from-selecting-string'
import store from '../init/store'

class DesktopSelectingCombatantTab extends React.Component {

  render() {
    const {vW, vH, viewportMode} = this.props;
    if (viewportMode === "portrait") {
      return null; //This is for Desktop only!
    }

    const style = {
      position: "absolute",
      // width: vW * 37,
      left: vW * 58,
      bottom: vH * 47,
      transform: isSubmissionMenuOpen() ? "translate3d(0,0,0)" : "translate3d(0,150%,0)",
      transition: "transform 0.3s"
    };

    const textContainerStyle = {
      width: "100%",
      textAlign: "center",
      paddingLeft: vW * 3,
    };

    const nameStyle = {
      fontSize: "0.5em",
      color: "#FCFCFC",
      textTransform: "uppercase"

    };

    const containerStyle = {
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-around",
    };
    const avatarContainerStyle = {
      position: "absolute",
      right: vW * 4,
      bottom: 0,
      width: vW * 8,
      height: vW * 8,
      overflow: "hidden",

    };

    const selectingPersonModel = store.getState().battle.combatants[
      getCombatantIdFromSelectingString(this.props.arenaSubmissionMenuCombatantIdLock || "")
    ];


    const displayName = selectingPersonModel
      ? selectingPersonModel.name
      : ""; //default to empty string if nobody is active


    const skinSrc = selectingPersonModel
      ? Skins()[selectingPersonModel.skinId].frontViewSrc
      : Skins()["skin_mystery"].frontViewSrc; //default to mystery person if nobody is active

    const avatarPersonStyle = {
      position: "absolute",
      top: vH * 4,
      width: vW * 8,
      height: vW * 8,
      background: `url(${skinSrc}) no-repeat no-repeat`,
      backgroundSize: "cover"
    };


    return (
      <div style={style}>
        <img alt="Tab" src="/images/misc/selecting-tab-background.svg" style={{width: vW * 37}}/>
        <div style={containerStyle}>
          <div style={textContainerStyle}>
            <div style={nameStyle}>
              {displayName}
            </div>
          </div>
          <div style={avatarContainerStyle}>
            <div style={avatarPersonStyle}/>
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state, props) => {
  return {
    viewportMode: state.global.viewportMode,
    vW: state.global.vW,
    vH: state.global.vH,
    arenaSubmissionMenuCombatantIdLock: state.battle.arenaSubmissionMenuCombatantIdLock,
  }
})(DesktopSelectingCombatantTab)


// WEBPACK FOOTER //
// ./src/battle/DesktopSelectingCombatantTab.js